import React, { useEffect, useRef } from "react";
import "./Home.css";

import topImage1 from "../Images/TopHeaderSection1.jpg";
import topImage2 from "../Images/TopHeaderSection2.jpg";
import topImage3 from "../Images/TopHeaderSection3.jpg";
import topImage4 from "../Images/TopHeaderSection4.jpg";
import market1 from "../Images/Markets4.jpg";
import market2 from "../Images/Markets1.jpg";
import market3 from "../Images/Markets2.jpg";
import market4 from "../Images/Markets3.jpg";
import logoSinolo from "../Images/logoSinolo.png";
import appleIcon from "../Images/apple.png";
import androidIcon from "../Images/google-play.png";

// Import your APK file - adjust the path to match your actual APK file location
import sinoloAPK from "../../sinolo/app-release.apk"; // Change this to your actual APK file path

const useAutoScroll = (ref, delay = 2000) => {
  useEffect(() => {
    const container = ref.current;
    if (!container || container.scrollWidth <= container.clientWidth) {
      return;
    }

    let index = 0;

    const intervalId = setInterval(() => {
      const node = ref.current;
      if (!node) {
        return;
      }

      if (node.scrollWidth <= node.clientWidth) {
        return;
      }

      const items = Array.from(node.children || []);
      if (items.length <= 1) {
        return;
      }

      index = (index + 1) % items.length;
      const target = items[index];
      if (!target || typeof target.scrollIntoView !== "function") {
        return;
      }

      target.scrollIntoView({
        behavior: "smooth",
        block: "nearest",
        inline: "center",
      });
    }, delay);

    return () => clearInterval(intervalId);
  }, [ref, delay]);
};

const Home = () => {
  const showcaseImages = [market1, market2, market3, market4];
  const heroGalleryRef = useRef(null);
  const showcaseRowRef = useRef(null);

  useAutoScroll(heroGalleryRef, 2000);
  useAutoScroll(showcaseRowRef, 2000);

  // Add download handler for APK file
  const handleAndroidDownload = (e) => {
    e.preventDefault();
    try {
      const link = document.createElement("a");
      link.href = sinoloAPK;
      link.download = "sinolo_app.apk";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error("Download failed:", error);
    }
  };

  return (
    <div className="sinolo-home">
      <header className="sinolo-hero">
        <h1 className="sinolo-hero__title">
          Get Factories &amp; Markets in China
        </h1>

        <div className="sinolo-hero__gallery">
          {[topImage1, topImage2, topImage3, topImage4].map((src, index) => (
            <div className="sinolo-hero__gallery-item" key={index}>
              <img src={src} alt={`Sinolo factory highlight ${index + 1}`} />
            </div>
          ))}
        </div>
        <div className="sinolo-hero__tagline">
          <span style={{ fontWeight: "bold", fontFamily: "NRT" }}>
            No middleman on
          </span>
          <img className="sinolo-logo" src={logoSinolo} alt="Sinolo logo" />
          <span style={{ fontWeight: "bold", fontFamily: "NRT" }}>
            just direct suppliers
          </span>
        </div>
      </header>

      <section className="sinolo-showcase">
        <div className="sinolo-showcase__column">
          <div className="sinolo-showcase__row" ref={showcaseRowRef}>
            {showcaseImages.map((src, index) => (
              <figure className="sinolo-showcase__card" key={index}>
                <img
                  src={src}
                  alt={`Sinolo marketplace preview ${index + 1}`}
                />
              </figure>
            ))}
          </div>
        </div>
      </section>

      <section className="sinolo-cta">
        <h2 className="sinolo-section-title">Now Available</h2>
        <div className="sinolo-cta__badges">
          <div className="sinolo-cta__badge-wrapper">
            <span className="sinolo-cta__badge-label">Download for iOS</span>
            <a
              className="sinolo-cta__badge sinolo-cta__badge--ios"
              href="https://apps.apple.com/us/app/sinolo/id6753020973"
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className="sinolo-cta__badge-icon" aria-hidden="true">
                <img
                  style={{
                    width: "37px",
                    height: "37px",
                  }}
                  src={appleIcon}
                  alt="Apple icon"
                />
              </div>
              <div className="sinolo-cta__badge-copy">
                <span>Download on The</span>
                <strong>App Store</strong>
              </div>
            </a>
          </div>

          <div className="sinolo-cta__badge-wrapper">
            <span className="sinolo-cta__badge-label">
              Download for Android
            </span>
            {/* Keep the same <a> tag structure, just change href and add onClick */}
            <a
              className="sinolo-cta__badge sinolo-cta__badge--android"
              href={sinoloAPK}
              download="sinolo_app.apk"
              onClick={handleAndroidDownload}
              target="_blank"
              rel="noopener noreferrer"
            >
              <div aria-hidden="true">
                <img
                  style={{
                    width: "33px",
                    height: "33px",
                  }}
                  src={androidIcon}
                  alt="Android icon"
                />
              </div>
              <div className="sinolo-cta__badge-copy">
                <span>Get it on</span>
                <strong>Google Play</strong>
              </div>
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;
